var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-resumecard-item", class: { "boss-check": _vm.check } },
    [
      _c("scout-resume-card-avatar", {
        attrs: {
          id: _vm.memberObject.id,
          member: _vm.memberObject.member,
          checked: _vm.checked,
          "is-scouted": _vm.isScouted,
          "is-show-checkbox": _vm.isShow,
          "is-scout-decline": _vm.isScoutDecline,
        },
        on: {
          change: function (arg) {
            return _vm.$emit("change", arg)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "boss-resumecard-item-right" }, [
        _c("div", { staticClass: "boss-resumecard-details" }, [
          _c(
            "div",
            { staticClass: "boss-resumecard-overview clearfix" },
            [
              _c("scout-resume-member-summary", {
                staticClass: "boss-resumecard-overview-title",
                attrs: { member: _vm.memberObject.member },
              }),
              _vm._v(" "),
              _c("dl", { staticClass: "boss-resumecard-overview-list" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "dd",
                  {
                    staticClass:
                      "boss-resumecard-overview-body boss-ellipsis-block",
                    attrs: { "data-test": "member_experienced_occupation" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("parseBlankForDefaultValue")(
                            _vm.presentOccupation
                          )
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "boss-resumecard-overview-list" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "dd",
                  {
                    staticClass:
                      "boss-resumecard-overview-body boss-ellipsis-block",
                    attrs: { "data-test": "member_desired_occupation" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("parseBlankForDefaultValue")(
                            _vm.convertObjectLabel(
                              _vm.memberObject.member.desiredOccupations
                            )
                          )
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boss-layout boss-layout-no-gap" }, [
                _c("dl", { staticClass: "boss-resumecard-overview-list" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass:
                        "boss-resumecard-overview-body boss-ellipsis-block",
                      attrs: { "data-test": "member_desired_work_prefecture" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.convertPrefectureLabel(
                                _vm.memberObject.member.desiredWorkPrefectures
                              )
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              !_vm.isScouted
                ? [
                    !_vm.isMaskingTarget
                      ? _c("scout-resume-card-detail", {
                          attrs: {
                            member: _vm.memberObject.member,
                            comment: _vm.comment,
                          },
                        })
                      : _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.maskingLabel) +
                              "\n          "
                          ),
                        ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isScouted
                ? _c("div", { staticClass: "boss-scout-mail" }, [
                    _c("ul", { staticClass: "boss-scout-status" }, [
                      _vm.scoutTitle
                        ? _c("li", { staticClass: "boss-scout-status-item" }, [
                            _c("div", { staticClass: "boss-ellipsis-block" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "boss-scout-status-date",
                                  attrs: { "data-test": "scout-datetime" },
                                },
                                [_vm._v(_vm._s(_vm.scoutDateTime))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "boss-scout-status-subject",
                                  attrs: { "data-test": "scout-title" },
                                },
                                [_vm._v(_vm._s(_vm.scoutTitle))]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.scoutedCounts
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "boss-scout-status-item boss-send-number",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "boss-scout-status-text",
                                  attrs: { "data-test": "scout-count" },
                                },
                                [_vm._v(_vm._s(_vm.scoutedCounts))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.scoutSpecialFavors && _vm.scoutSpecialFavors.length
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "boss-scout-status-item boss-scout-bonus",
                            },
                            _vm._l(
                              _vm.scoutSpecialFavors,
                              function (specialFavor, index) {
                                return _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content:
                                            _vm.getSpecialFavorTooltip(
                                              specialFavor
                                            ),
                                        },
                                        expression:
                                          "{ content: getSpecialFavorTooltip(specialFavor)}",
                                      },
                                    ],
                                    key: index,
                                    staticClass:
                                      "boss-bonus-check-text boss-check-true",
                                    class: {
                                      "boss-bonus-end":
                                        !specialFavor.isEffective,
                                    },
                                    attrs: {
                                      "data-test":
                                        "scout-special-favor-" + index,
                                    },
                                  },
                                  [_vm._v(_vm._s(specialFavor.name))]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.memberObject.member.searchConditionName
                ? _c("div", { staticClass: "boss-scout-status-item" }, [
                    _c(
                      "span",
                      {
                        staticClass: "boss-scout-status-text",
                        attrs: { "data-test": "member-search-condition-name" },
                      },
                      [
                        _vm._v(
                          "検索条件名：" +
                            _vm._s(_vm.memberObject.member.searchConditionName)
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "boss-resumecard-button-list" }, [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout boss-layout-vertical boss-layout-fill",
              },
              [
                _vm.isExcluded
                  ? _c("div", { staticClass: "resumecard-button-list-list" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "boss-button boss-button-strong boss-button-fill boss-button-small",
                          attrs: { "data-test": "restore" },
                          on: { click: _vm.onRestoreClick },
                        },
                        [_c("span", [_vm._v("検索対象に戻す")])]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showsScoutButton && !_vm.isMaskingTarget && _vm.canApproach
                  ? _c("div", { staticClass: "resumecard-button-list-list" }, [
                      _vm.isReserved
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "boss-button boss-button-strong boss-button-fill boss-button-small pega-button boss-button-pushed",
                              attrs: {
                                type: "button",
                                "data-test": "scout-reserved",
                              },
                            },
                            [_vm._v("予約中")]
                          )
                        : _vm.isScoutInvalid
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "boss-button boss-button-strong boss-button-fill boss-button-small pega-button",
                              attrs: {
                                disabled: "",
                                type: "button",
                                "data-test": "scout-invalid",
                              },
                            },
                            [_vm._v("再送期限切れ")]
                          )
                        : _c(
                            "a",
                            {
                              staticClass:
                                "boss-button boss-button-strong boss-button-fill boss-button-small",
                              attrs: { "data-test": "scout-create" },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    name: "scoutCreate",
                                    params: {
                                      idAndNameObjects: [
                                        {
                                          userId: _vm.memberObject.member.id,
                                          searchConditionName:
                                            _vm.searchConditionName,
                                        },
                                      ],
                                      jobId: _vm.jobId,
                                      contractId: _vm.contractId,
                                    },
                                  })
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "boss-icon boss-icon-scout boss-button-icon-large",
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("スカウト")]),
                            ]
                          ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "resumecard-button-list-list" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "boss-button boss-button-outline boss-button-fill boss-button-small",
                      attrs: {
                        "data-open": "boss-modal-control",
                        "data-test": "open-detail",
                      },
                      on: { click: _vm.onReveal },
                    },
                    [_c("span", [_vm._v("詳細を見る")])]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("scout-member-detail", {
        attrs: {
          id: _vm.memberObject.id,
          "contract-id": _vm.contractId,
          "job-id": _vm.jobId,
          "show-detail": _vm.showDetail,
          "user-id": _vm.memberObject.member.id,
          "search-condition-name": _vm.searchConditionName,
          "is-show-checked-close-button": _vm.isShow,
          "shows-excluded-button": _vm.showsExcludedButton,
          "is-scout-decline": _vm.isScoutDecline,
        },
        on: {
          "check-from-child": _vm.checkFromChild,
          "update-comment": _vm.updateComment,
          "update-member-excluded": _vm.updateMemberExcluded,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [
        _vm._v("直近の経験職種"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [_vm._v("希望職種")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [
        _vm._v("希望勤務地"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }